import {AuthInitialState} from '../states';
import * as Actions from './actions';

const authReducer = (state = AuthInitialState, action) => {
    switch(action.type) {
        case Actions.SET_USER_PROFILE:
            return {...state, userProfile: action.payload};
        case Actions.SET_USER_EMAIL:
            return {...state, userEmail: action.payload};
        case Actions.SET_USER_IDENTITY_ID:
            return {...state, identityId: action.payload};
        case Actions.SET_USER_INFO:
            return {...state, info: {...action.payload}};
        default:
            return {...state}
    }
}

export default authReducer